export default "__VITE_ASSET__n2HHw5bD__"